import {ApplicationConfig, provideZonelessChangeDetection} from '@angular/core';
import { environment } from '../environments/environment';
import {provideClientHydration, withHttpTransferCacheOptions} from "@angular/platform-browser";
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from "@angular/common/http";
import {ConfirmationService, MessageService} from "primeng/api";
import {AuthGuard} from "./guards/auth-guard";
import {AuthInterceptor} from "./interceptor/auth-interceptor";
import {provideRouter, withInMemoryScrolling} from "@angular/router";
import {provideAnimationsAsync} from "@angular/platform-browser/animations/async";
import {RECAPTCHA_V3_SITE_KEY} from "ng-recaptcha";
import {provideNgxStripe} from "ngx-stripe";
import {routes} from "./routes/routes";
import {providePrimeNG} from "primeng/config";
import Aura from '@primeng/themes/aura';
import {WebsocketService} from "./services/websocket.service";
import {BartenderGuard} from "./guards/bartender-guard";
import {CustomerGuard} from "./guards/customer-guard";
import {AnonymousGuard} from "./guards/anonymous-guard";

export const appConfig: ApplicationConfig = {
  providers: [
    provideHttpClient(withInterceptorsFromDi()),
    provideRouter(routes, withInMemoryScrolling({
      scrollPositionRestoration: 'enabled',
    })),
    provideNgxStripe(),
    provideClientHydration(
      withHttpTransferCacheOptions({
        includePostRequests: false,
        includeRequestsWithAuthHeaders: true
      })
    ),
    provideZonelessChangeDetection(),
    provideAnimationsAsync(),
    providePrimeNG({
      translation: {
        accept: 'Accepter',
        reject: 'Annuler',
        firstDayOfWeek: 1,
        dayNames: [ 'dimanche', 'lundi', 'mardi', 'mercredi', 'jeudi', 'vendredi', 'samedi' ],
        dayNamesShort: [ 'dim', 'lun', 'mar', 'mer', 'jeu', 'ven', 'sam' ],
        dayNamesMin: [ 'D', 'L', 'M', 'M', 'J', 'V', 'S' ],
        monthNames: [ 'Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin',
          'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre' ],
        monthNamesShort: [ 'Janv.', 'Févr.', 'Mars', 'Avr.', 'Mai', 'Juin', 'Juill.', 'Août', 'Sept.', 'Oct.', 'Nov.', 'Déc.' ],
        today: 'Aujourd\'hui',
        clear: 'Effacer',
        aria: {
          nextPageLabel: 'Page suivante',
          prevPageLabel: 'Page précédente',
          firstPageLabel: 'Première page',
          lastPageLabel: 'Dernière page',
          pageLabel: 'Page {page}' // Cibler les indicateurs de pages (points)
        }
      },
      theme: {
        preset: Aura,
        options: {
          cssLayer: {
            name: 'primeng',
            order: 'primeng, app'
          },
          darkModeSelector: '.app-dark'
        }
      }
    }),
    MessageService,
    AuthGuard,
    BartenderGuard,
    CustomerGuard,
    AnonymousGuard,
    WebsocketService,
    ConfirmationService,
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    { provide: RECAPTCHA_V3_SITE_KEY, useValue: environment.google.recaptcha }
  ]
}
